export default __webpack_public_path__ + "static/media/0x692ac1e363ae34b6b489148152b12e2785a3d8d6.2960c74e.webp";